import React from 'react';

import DateTimeUtils from '../../../common/utils/DateTimeUtils';

import DataItemView from '../../../common/view/DataItemView';
import ModifiedFlag from '../../../common/controls/ModifiedFlag';
import ErrorFlag from '../../../common/controls/ErrorFlag';

import MetadataEditor from '../../../common/metadata/MetadataEditor';

export default class SettingValuesView extends DataItemView {
  static displayName = SettingValuesView.name;

  constructor(props) {
    super(props);
    this.onEditorValueListener = this.onEditorValueChanged.bind(this);
    this.bindDataItem(props.settingValues);
  }

  componentDidUpdate() {
    this.bindDataItem(this.props.settingValues);
  }

  render() {
    if (!this.state.isDataBound)
      return (
        <div className="pwx-settings-list" />
      );
    
    return (
      <div className="pwx-settings-list">
        {
          this.props.settingViewGroups.map(settingViewGroup =>
          (
            <div key={settingViewGroup.category} className="pwx-category-group">
              <div className="pwx-category-name">{settingViewGroup.category}</div>
              {
                settingViewGroup.settings.map((setting, index, array) =>
                (
                  <div className="pwx-setting-grid pwx-field" key={setting.identifier}>
                    <div className="pwx-setting-cell pwx-field-label">{this.state[setting.identifier + '_displayName']}:</div>
                    <div className="pwx-setting-cell pwx-field-spacer" />
                    <div className="pwx-setting-cell pwx-field-value">
                      <MetadataEditor
                        height="30px"
                        name={setting.identifier}
                        value={this.state[setting.identifier]}
                        metadataRule={this.state[setting.identifier + '_metadataRule']}
                        onValueChanged={this.onEditorValueListener}
                      />
                    </div>
                    <div className="pwx-setting-cell">
                      <ModifiedFlag isModifiedProperty={this.state[setting.identifier + '_isModified']} />
                      <ErrorFlag errorProperty={this.state[setting.identifier + '_error']} />
                    </div>
                    <div className="pwx-setting-cell pwx-field-units-spacer" />
                    <div className="pwx-setting-cell pwx-field-label">{setting.units}</div>
                    <div className="pwx-setting-cell" />
                    <div className="pwx-setting-full-row pwx-field-description">{setting.description}</div>
                    <div className="pwx-setting-full-row pwx-field-update-details">
                      {DateTimeUtils.formatShortDateTime(this.state[setting.identifier + '_lastUpdatedTime'])}
                      &nbsp;|&nbsp;
                      {this.state[setting.identifier + '_lastUpdatedBy']}
                    </div>
                  </div>
                ))
                }
            </div>
          ))
        }
      </div>
    );
  }

  onEditorValueChanged(propertyName, value) {
    if (this.dataItem !== null)
      this.dataItem.updateProperty(propertyName, value);
  }
}